import { useCallback } from "react";
import { EntityPreviewsLayout } from "../../shared/layouts/EntityPreviewsLayout";
import type { EntityScope } from "../../shared/scope";
import { AdminAccountSubmissionPreviewsAll } from "./AdminAccountSubmissionPreviewsAll";
import { AdminAccountSubmissionPreviewsClosed } from "./AdminAccountSubmissionPreviewsClosed";
import { AdminAccountSubmissionPreviewsOpen } from "./AdminAccountSubmissionPreviewsOpen";
import { SubmissionMetricsView } from "./submissions-metrics/SubmissionMetricsView";

export const AdminAccountSubmissionsView = () => {
	const renderMetrics = useCallback(
		(scope: EntityScope) => <SubmissionMetricsView scope={scope} />,
		[],
	);

	return (
		<EntityPreviewsLayout
			title="Account Submissions"
			storageKey="admin_account_submissions_view"
			enableScope
			renderMetrics={renderMetrics}
			tabs={[
				{
					id: "all",
					label: "All",
					Component: AdminAccountSubmissionPreviewsAll,
				},
				{
					id: "open",
					label: "Open",
					Component: AdminAccountSubmissionPreviewsOpen,
					isDefault: true,
				},
				{
					id: "closed",
					label: "Closed",
					Component: AdminAccountSubmissionPreviewsClosed,
				},
			]}
		/>
	);
};
